import React from "react";
import withStyles from '@mui/styles/withStyles';
import { Box, Typography } from "@mui/material";

const styles = (theme) => ({
  statistic: {
    fontSize: 16,
    fontWeight: 600,
    color: "#000",
  },
  progressContainer: {
    backgroundColor: "#ebebeb",
    height: 14,
    width: 80,
    borderRadius: 10,
  },
  courseNameContainer: { width: "100%", borderBottom: "1px solid #ebebeb" },
  allCredits: { fontSize: "20px" },
  achievedCredits: { fontSize: "16px", display: "flex", alignItems: "center" },
});

const ProgressBarRow = ({ classes, statistic }) => {
  return (
    <>
      <Box key={statistic.courseId} display="flex" alignItems="center" mb={1}>
        <Box className={classes.courseNameContainer}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Typography
              className={classes.statistic}
              style={
                statistic.progress === 0
                  ? { color: "gray", fontWeight: 100 }
                  : null
              }
              variant="body1"
              component="div"
              color="secondary"
            >
              <p> {statistic.courseName}</p>
            </Typography>
            <Typography
              className={classes.statistic}
              variant="body1"
              component="div"
              color="secondary"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <p
                  className={classes.achievedCredits}
                  style={{ marginRight: "5px" }}
                >
                  {statistic.progress}
                </p>
                <p className={classes.achievedCredits}>/</p>
                <p className={classes.allCredits} style={{ marginLeft: "5px" }}>
                  {statistic.credits}
                </p>
              </div>
            </Typography>
          </div>
        </Box>
      </Box>
    </>
  );
};

export default withStyles(styles)(ProgressBarRow);
